import React, { useState } from "react";
import useHttpRequests from "../../../hooks/useHttpRequests";
import { TableWithStickyHeader } from "../../uiControls/tableWithStickyHeader";
import { FunctionalAreaUpdate } from "./functionalAreaUpdate";
import { ConfirmationDialog } from "../../common/confirmationDialog";
import { AddNew } from "../../uiControls/addNew";

const functionalAreaColumns = [
  {
    label: "Functional Area",
    keyField: "functionalAreaKey",
    dataField: "name",
  },
  {
    label: "Description",
    keyField: "functionalAreaKey",
    dataField: "description",
  },
  {
    label: "Status",
    keyField: "functionalAreaKey",
    dataField: "active",
    minWidth: 20,
    maxWidth: 20,
  },
  {
    label: "",
    keyField: "functionalAreaKey",
    dataField: "functionalAreaKey",
    minWidth: 20,
    maxWidth: 20,
  },
];

const functionalAreaSearchColumns = ["name", "description"];

export const FunctionalAreaConfig = () => {
  const [updateOpen, setUpdateOpen] = useState(false);
  const [functionalAreaEdit, setFunctionalAreaEdit] = useState(null);
  const [functionalAreaAttributes, setFunctionalAreaAttributes] = useState({
    functionalAreaKey: 0,
    name: "",
    description: "",
    active: true,
  });
  const [dialogOpen, setDialogOpen] = useState(false);
  const [confirmationDialogAttributes, setConfirmationDialogAttributes] =
    useState({});

  const { sendRequest: fetchFunctionalAreaDetails } = useHttpRequests();

  const functionalAreaEditHandler = (e, key) => {
    e.stopPropagation();
    if (updateOpen) {
      //alert("Are you sure to discard your changes?");
      //TODO: confirmation for data loss
      return false;
    }

    const getFunctionalAreaDetails = (functionalAreaObj) => {
      if (
        !functionalAreaObj ||
        !functionalAreaObj.isSuccess ||
        functionalAreaObj.errorResponse
      ) {
        console.log("Functional area fetch response returns error");
        return;
      }

      setFunctionalAreaAttributes({
        functionalAreaKey:
          functionalAreaObj["functionalArea"]["functionalAreaKey"],
        name: functionalAreaObj["functionalArea"]["name"],
        description: functionalAreaObj["functionalArea"]["description"],
        active: functionalAreaObj["functionalArea"]["active"],
      });

      setFunctionalAreaEdit(true);
      setUpdateOpen(true);
    };

    fetchFunctionalAreaDetails(
      { url: "FunctionalAreas/" + key, method: "GET", header: true },
      getFunctionalAreaDetails
    );
  };

  const changeFunctionalAreaStatus = (e, key, status, name) => {
    e.stopPropagation();
    if (updateOpen || dialogOpen) {
      return false;
    }
    setConfirmationDialogAttributes({
      title: "Functional area status change confirmation!",
      message:
        "Are you sure to mark " +
        (status ? "active" : "inactive") +
        " the " +
        name +
        "?",
      confirmText: "Yes",
      cancelText: "No",
      url: "FunctionalAreas/",
      keyField: "functionalAreaKey",
      key: key,
      status: status,
      messageTitle: name,
    });
    setDialogOpen(true);
  };

  const getUrl = (params) => {
    return "FunctionalAreas";
  };

  const functionalAreaDetailProps = {
    setUpdateOpen,
    functionalAreaEdit,
    setFunctionalAreaEdit,
    functionalAreaAttributes,
  };

  return (
    <div
      style={{
        display: "flex",
        flexFlow: "column",
        height: "calc(100vh - 160px)",
      }}
    >
      <ConfirmationDialog
        open={dialogOpen}
        setDialogOpen={setDialogOpen}
        confirmationDialogAttributes={confirmationDialogAttributes}
      />
      <div
        style={{
          display: "flex",
          flexFlow: "column",
          gap: "20px",
          width: "100%",
        }}
      >
        {!updateOpen && (
          <>
            <TableWithStickyHeader
              pagging={false}
              columns={functionalAreaColumns}
              url={getUrl}
              sourceObj="functionalAreas"
              editHandler={functionalAreaEditHandler}
              updateOpen={updateOpen}
              searchOnColumns={functionalAreaSearchColumns}
              changeStatus={changeFunctionalAreaStatus}
              searchPlace="right"
            />

            <AddNew
              onClickCall={() => {
                setFunctionalAreaAttributes({
                  functionalAreaKey: 0,
                  name: "",
                  description: "",
                  active: true,
                });
                setUpdateOpen(true);
              }}
            />
          </>
        )}
      </div>

      {updateOpen && (
        <div
          style={{
            display: "flex",
            width: window.innerWidth <= 1366 ? "100%" : "65%",
          }}
        >
          <FunctionalAreaUpdate {...functionalAreaDetailProps} />
        </div>
      )}
    </div>
  );
};
